module.exports = __webpack_public_path__ + "static/img/ptld_5@2x.500817ab.png";